// extracted by mini-css-extract-plugin
export default {"image_gallery_container":"styles_image_gallery_container__iuct7","image_gallery_swiper":"styles_image_gallery_swiper__dYK2f","swiper-wrapper":"styles_swiper-wrapper__8XtI-"};